var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('AppTopbar'),_c('v-main',{staticClass:"container mt-5 mt-md-10 px-3"},[_vm._t("default")],2),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }